var UUID_RE = /[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}/;

var pdfjsLibPromise = null;

function cargarPdfjsLib() {
  if (!pdfjsLibPromise) {
    pdfjsLibPromise = import("pdfjs-dist").then(function(pdfjsLib){
      pdfjsLib.GlobalWorkerOptions.workerSrc = (process.env.PUBLIC_URL || "") + "/pdf.worker.min.mjs";
      return pdfjsLib;
    });
  }
  return pdfjsLibPromise;
}

export async function extraerUUIDdePDF(file) {
  var pdfjsLib = await cargarPdfjsLib();
  var buffer = await file.arrayBuffer();
  var pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
  for (var i = 1; i <= pdf.numPages; i++) {
    var page = await pdf.getPage(i);
    var textContent = await page.getTextContent();
    var text = textContent.items.map(function(item){ return item.str; }).join(" ");
    var match = text.match(UUID_RE);
    if (match) return match[0].toUpperCase();
  }
  return null;
}
